export const ASSEMBLIES = {
  STATUS: {
    STATUS_DRAFT: "draft",
    STATUS_SCHEDULED: "scheduled",
    STATUS_OPEN: "open",
    STATUS_CLOSED: "closed",
  },
};
